export const timeDiffCalc = (dateFuture: Date, dateNow: Date) => {
    let diffInMilliSeconds = Math.abs(dateFuture.getTime() - dateNow.getTime()) / 1000;

    // calculate days
    const days = Math.floor(diffInMilliSeconds / 86400);
    diffInMilliSeconds -= days * 86400;

    // calculate hours
    const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
    diffInMilliSeconds -= hours * 3600;

    // calculate minutes
    const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
    diffInMilliSeconds -= minutes * 60;

    let difference = '';

    difference += (hours === 0 || hours === 1) ? `${hours} hr ` : `${hours} hrs `;

    difference += (minutes === 0 || hours === 1) ? `${minutes} min` : `${minutes} mins`; 

    return {days, hours, minutes, difference};
  }